import { render, staticRenderFns } from "./forecast-gold.vue?vue&type=template&id=312b96e4&scoped=true&"
import script from "./forecast-gold.vue?vue&type=script&lang=js&"
export * from "./forecast-gold.vue?vue&type=script&lang=js&"
import style0 from "./forecast-gold.vue?vue&type=style&index=0&id=312b96e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b96e4",
  null
  
)

export default component.exports